import { css } from '@backyard-ui/styles';

const styles = css({
  display: 'inline-flex',

  alignItems: 'center',
  justifyContent: 'center',

  width: '$full',
  height: 'auto',

  fontWeight: '$normal',
  lineHeight: 1,

  color: '$n900',

  appearance: 'none',

  borderColor: '$n300',
  borderRadius: '$md',
  borderStyle: 'solid',
  borderWidth: '$xs',

  background: '$white',

  outline: 'none',

  transitionProperty:
    'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
  transitionDuration: '200ms',

  '&::placeholder': {
    color: '$n300',
  },

  '&:focus': {
    focus: '$p300',
    borderColor: '$p600',
  },

  '&:hover': {
    borderColor: '$n600',
  },

  '&:disabled, &[disabled]': {
    color: '$n300',
    background: '$n100',
    pointerEvents: 'none',
  },

  '&[readOnly]': {
    background: '$n100',
  },

  variants: {
    size: {
      xs: {
        height: '$7',
        paddingX: '$3',
        fontSize: '$tsm',
      },
      sm: {
        height: '$10',
        paddingX: '$4',
        fontSize: '$tlg',
      },
      md: {
        height: '$12',
        paddingX: '$6',
        fontSize: '$txl',
      },
    },
    isInvalid: {
      true: {
        focus: '$c300',
        borderColor: '$c600',
      },
    },
  },

  defaultVariants: {
    size: 'sm',
  },
});

export default styles;
